import { ORPHAN_REVIEW_COMPANY_ID, useConfig } from '@seek/libs-shared';
import { useTranslations } from '@vocab/react';
import { Actions, Box, Button, Heading, Stack } from 'braid-design-system';
import { useEffect } from 'react';
import { CompanySearchCard } from '../../companyProfiles/components/companySearchCard/CompanySearchCard';
import type { SearchCompanyProfileResult } from '../../shared/services/companyProfileService/types';
import {
  CURRENT_PAGE_COMPANY_INTERCEPT,
  trackDisplayPage,
} from '../../shared/tracking/writeAReview/trackingEvents';
import type { ReviewFormContext } from '../type';
import translations from './.vocab';

export const CompaniesListPage = ({
  searchCompanyProfileResult,
  handleOnCompanyNameClick,
  handleOnDisambiguationBackClick,
  reviewFormContext,
}: {
  handleOnCompanyNameClick: (index: number) => void;
  handleOnDisambiguationBackClick: () => void;
  reviewFormContext: ReviewFormContext;
  searchCompanyProfileResult: SearchCompanyProfileResult;
}) => {
  const { t } = useTranslations(translations);
  const config = useConfig();

  useEffect(() => {
    if (reviewFormContext?.variant) {
      trackDisplayPage({
        config,
        context: reviewFormContext,
        currentPage: CURRENT_PAGE_COMPANY_INTERCEPT,
        variant: reviewFormContext.variant,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reviewFormContext?.variant]);
  return (
    <Box
      paddingTop={{ tablet: 'xxlarge', mobile: 'large' }}
      data={{ testid: 'company-list-page' }}
    >
      <Stack space="xxlarge">
        <Heading level="1">{t('Select a company to review')}</Heading>
        <Stack space="large">
          {searchCompanyProfileResult.map((company, index) => {
            if (company.companyId !== ORPHAN_REVIEW_COMPANY_ID) {
              return (
                <CompanySearchCard
                  key={`${company.companyId}-${index}`}
                  logo={company.logoUrl}
                  name={company.name}
                  onClick={() => handleOnCompanyNameClick(index)}
                />
              );
            }
            return null;
          })}
        </Stack>
        <Actions>
          <Button onClick={handleOnDisambiguationBackClick}>
            {t('Review a different company')}
          </Button>
        </Actions>
      </Stack>
    </Box>
  );
};
